import classNames from "classnames";
import { ComponentProps, CSSProperties } from "react";
import styles from "./FrontPageShowsStyles.module.css";

type SProgramSectionProps = ComponentProps<"section">;

export function SProgramSection({ className, children, ...rest }: SProgramSectionProps) {
    return <section className={classNames(styles.SProgramSection, className)} {...rest}>{children}</section>
}

type SParagraphProps = ComponentProps<"p">;

export function SError({ className, children, ...rest }: SParagraphProps) {
    return <p className={classNames(styles.SError, className)} {...rest}>{children}</p>
}

export function SNoShows({ className, children, ...rest }: SParagraphProps) {
    return <p className={classNames(styles.SNoShows, className)} {...rest}>{children}</p>
}

type SShowsContainerProps = ComponentProps<"div"> & {
    $count: number;
    $columns?: number;
};

export function SShowsContainer({ className, children, $count, $columns, ...rest }: SShowsContainerProps) {
    const style = {
        "--container-columns": $columns ?? 3,
    };

    let clsName = className;

    if ($count < 3 && $count !== 0) {
        clsName = classNames(styles.LowCount, clsName);
    }

    return <div className={classNames(styles.SShowsContainer, clsName)} style={style as CSSProperties}>{children}</div>
}
